// extracted by mini-css-extract-plugin
export default {"attachmentList":"EEGVQclOMHqCnenRI0vx","footer":"_5TYBIlvFaAQulJmtpL9g","inModal":"_YGoRwh35oZ8x9W4EMim","in-modal":"bHLXb6cw80lZhitukd1K"};